import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-editted-successfully',
  templateUrl: './editted-successfully.component.html',
  styleUrls: ['./editted-successfully.component.scss']
})
export class EdittedSuccessfullyComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      url: any,
      name: string,
      type: string,
    },
    private snackBar: MatSnackBar,
    private router: Router,
    private dialog: MatDialog,
    public translate: TranslateService,
    private languageService: LanguageService
  ) { }

  ngOnInit() {
    if (localStorage.getItem("language")) {
      this.translate.use(localStorage.getItem("language"));
    } else {
      this.translate.use('en');
    }
    this.languageService.languageUpdated.subscribe((lang: string) => {
      this.translate.use(lang);
    });
  }

  copyInputMessage(text: any) {
    let message = '';
    try {
      const selBox = document.createElement('textarea') as HTMLTextAreaElement;
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = text;
      document.body.appendChild(selBox);
      selBox.select();
      const success = document.execCommand('copy');
      document.body.removeChild(selBox);
      message = success ? this.translate.instant('Sellers.Products.CopiedToClipboard') : this.translate.instant('Sellers.Products.UnableToCopy');
    } catch (err) {
      message = this.translate.instant('Sellers.Products.UnableToCopy');
    } finally {
      this.snackBar.open(message, '', { duration: 2000 });
    }
  }

  goToProductManagement() {
    if (this.data.type == "Collection"){
      this.router.navigate(['seller/claims/management']);
    } else {
      this.router.navigate(['seller/products/management']);
    }
    this.dialog.closeAll();
  }
}
